import { render, staticRenderFns } from "./WsDeCenterList.vue?vue&type=template&id=3179f284&scoped=true"
import script from "./WsDeCenterList.vue?vue&type=script&lang=js"
export * from "./WsDeCenterList.vue?vue&type=script&lang=js"
import style0 from "./WsDeCenterList.vue?vue&type=style&index=0&id=3179f284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179f284",
  null
  
)

export default component.exports